<rk-platform-publishing-shell>
  <div class="flex gap-2 mb-8 items-center">
    <fa-icon class="opacity-50 text-2xl" [icon]="['fab', 'android']"></fa-icon>
    <span class="text-xl font-bold">Android</span>
  </div>
  <div class="publishing-steps overflow-auto">
    @if (playStoreLink$ | async) {
      <rk-android-screenshot></rk-android-screenshot>
    } @else {
      @if (androidPublishingData$ | async; as androidData) {
        @for (step of androidData.steps; track step.name) {
          <rk-publishing-step
            [stepType]="step.name"
            [status]="step.status"
            [ctaLink]="step.url"
            platform="android"
          >
          </rk-publishing-step>
        }
      }
    }
  </div>
</rk-platform-publishing-shell>
